import api from './api';

export const proposalService = {
   getAll: (params) => api.get('/proposals', { params }).then((r) => r.data),
   getById: (id) => api.get(`/proposals/${id}`).then((r) => r.data),
   create: (data) => api.post('/proposals', data).then((r) => r.data),
   update: (id, data) => api.put(`/proposals/${id}`, data).then((r) => r.data),
   delete: (id) => api.delete(`/proposals/${id}`).then((r) => r.data),
   duplicate: (id) => api.post(`/proposals/${id}/duplicate`).then((r) => r.data),
   regenerateToken: (id) => api.post(`/proposals/${id}/regenerate-token`).then((r) => r.data),
   uploadAttachment: (file) => {
      const form = new FormData();
      form.append('file', file);
      return api
         .post('/proposals/upload-attachment', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
         })
         .then((r) => r.data);
   },
};
